import { CounterOfferOutcome } from "src/utils/redux/slices/counterOffer";
import { trackBuyflowEvent, trackEvent } from "src/utils/api/tracker";
import { isOver30DaySubscriber } from "src/utils/userSegment";
import getStore from "src/utils/redux/store";
import saveToBraze from "src/utils/brazeUploader";

export const trackCancellationSurveyFinished = () => {
  const state = getStore().getState();
  const { serverContext, counterOffer, currentAnswers } = state;
  const currentCounterOfferAnswers =
    currentAnswers?.questionAnswers["userData.counterOfferAnswers"];
  const eventParams = {
    isInTrial: serverContext.is_in_trial,
    upid: serverContext.upid,
    subscriptionIsHM: serverContext.subscription_is_hm,
    programDay: isOver30DaySubscriber() ? "after30" : "before30",
  };
  const { outcome } = counterOffer;
  const canceled = [
    CounterOfferOutcome.CANCEL,
    CounterOfferOutcome.CANCEL_MED,
    CounterOfferOutcome.CANCEL_WHOLE_HEALTH,
    CounterOfferOutcome.CANCEL_MEMBERSHIP,
    CounterOfferOutcome.CANCEL_MEDICATION,
  ].includes(outcome);
  const outcomeIsNotAnOffer =
    !outcome ||
    [
      CounterOfferOutcome.CANCEL,
      CounterOfferOutcome.CANCEL_MED,
      CounterOfferOutcome.CANCEL_WHOLE_HEALTH,
      CounterOfferOutcome.CANCEL_MEMBERSHIP,
      CounterOfferOutcome.CANCEL_MEDICATION,
      CounterOfferOutcome.ERROR,
      CounterOfferOutcome.INVALID_SUBSCRIPTION,
    ].includes(outcome);
  trackEvent("FinishedCancellationSurvey", {
    ...currentCounterOfferAnswers,
    ...eventParams,
  });
  const cancellationFinishedData = {
    canceled,
    cancellationOffersAccepted: outcomeIsNotAnOffer ? [] : [outcome],
    cancellationOffersRejected: counterOffer.cancellationOffersRejected,
    cancellationOffersFailed: counterOffer.cancellationOffersFailed,
  };
  saveToBraze({
    event: {
      event_name: "CancellationSurveyFinished",
      event_data: {
        ...cancellationFinishedData,
        likelyToTryAgainInFuture:
          currentCounterOfferAnswers?.likelyToTryAgainInFuture,
        medCancellationReason:
          currentCounterOfferAnswers?.medCancellationReason,
        cancellationReason:
          currentCounterOfferAnswers?.cancellationReason ||
          currentCounterOfferAnswers?.wholeHealthCancellationReason ||
          currentCounterOfferAnswers?.membershipCancellationReason ||
          currentCounterOfferAnswers?.medicationCancellationReason,
      },
    },
  });
  trackBuyflowEvent("CancellationSurveyFinished", cancellationFinishedData);
};
